<template>
  <div class="mobile-sidebar">
    <div class="mobile-sidebar__left" aria-hidden="true" @click="onToBottom">
      <img
        src="@/assets/image/index/to_bottom.webp"
        alt="Scroll to bottom of page"
        width="40"
        height="54"
        decoding="async"
      />
    </div>

    <button type="button" class="mobile-sidebar__right" @click="onToTop">
      <img
        src="@/assets/image/index/to_top.webp"
        alt="Scroll to top of page"
        width="40"
        height="54"
        decoding="async"
      />
    </button>
  </div>
</template>
<script>
export default {
  name: "MobileSidebar",
  methods: {
    onToTop() {
      this.$emit("to-top");
    },
    onToBottom() {
      this.$emit("to-bottom");
    }
  },
};
</script>
<style lang="scss" scoped>
.mobile-sidebar {
  img {
    width: 40px;
    height: 54px;
  }
  &__left,
  &__right {
    position: fixed;
    z-index: 19;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: transform 0.2s ease, opacity 0.2s ease;

    &:active {
      transform: scale(0.92);
      opacity: 0.88;
    }
  }

  &__left {
    bottom: 140px;
    left: 0;
  }

  &__right {
    bottom: 152px;
    right: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .mobile-sidebar__left,
  .mobile-sidebar__right {
    transition: none;
    &:active {
      transform: none;
      opacity: 1;
    }
  }
}
</style>
